/* <lystia-article>: зміст (h2 з тексту статті), індикатор читання, «Поділитися». T-E8-03 / T-E8-04.
   A-147: розміщення короткого квізу і «Що заварити» в тексті, FAQ-акордеон (.lacc-*), CTA «Пройти тест» у тілі, sticky-кнопка, події PostHog. */
if (!customElements.get('lystia-article')) {
  class LystiaArticle extends HTMLElement {
    connectedCallback() {
      if (this._done) return;
      this._done = true;
      this._wrapTables();
      this._placeBlocks();
      this._bindFaq();
      this._fixBodyCta();
      this._buildToc();
      this._bindProgress();
      this._bindShare();
      this._bindSticky();
      this._bindProdsNav();
      this._bindTrack();
    }

    disconnectedCallback() {
      if (this._onScroll) {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
      }
      if (this._io) this._io.disconnect();
      this._io = null;
      if (this._onScrollSticky) window.removeEventListener('scroll', this._onScrollSticky);
      if (this._onProdsResize) window.removeEventListener('resize', this._onProdsResize);
      this._onProdsResize = null;
      this._onScrollSticky = null;
      if (this._raf) cancelAnimationFrame(this._raf);
      this._done = false;
      this._onScroll = null;
      this._raf = 0;
    }

    /* Таблиці без обгортки .tbl (старі статті): обгортаємо й додаємо data-label із <th>, щоб на мобільному були картки, а не широка таблиця. */
    _wrapTables() {
      document.querySelectorAll('.prose table').forEach((t) => {
        if (t.closest('.tbl')) return;
        const heads = [...t.querySelectorAll('thead th')].map((th) => th.textContent.trim());
        t.querySelectorAll('tbody tr').forEach((tr) => {
          [...tr.children].forEach((td, i) => {
            if (!td.hasAttribute('data-label')) td.setAttribute('data-label', i === 0 ? '' : (heads[i] || ''));
          });
        });
        const w = document.createElement('div');
        w.className = 'tbl';
        t.parentNode.insertBefore(w, t);
        w.appendChild(t);
      });
    }

    /* A-147: H2 «Часті питання»/FAQ або h2 перед .lart-faq; «Читай також» у тілі старих статей */
    _faqHead(prose) {
      const faq = prose.querySelector('.lart-faq');
      if (faq) {
        let p = faq.previousElementSibling;
        while (p && p.tagName !== 'H2') p = p.previousElementSibling;
        if (p) return p;
      }
      return Array.from(prose.querySelectorAll('h2')).find((h) => /^(часті питання|faq)$/i.test(h.textContent.trim())) || null;
    }

    /* Квіз: перед 3-м H2 тексту (якщо H2 ≥ 4), інакше перед FAQ, інакше лишається після тексту.
       «Що заварити»: перед FAQ, інакше перед «Читай також» у тілі, інакше після тексту. Без JS блоки стоять після тексту. */
    _placeBlocks() {
      const prose = this.querySelector('[data-art-prose]');
      if (!prose) return;
      const quiz = this.querySelector('[data-art-quiz]');
      const prods = this.querySelector('[data-art-prods]');
      const h2 = Array.from(prose.children).filter((el) => el.tagName === 'H2');
      const faqH = this._faqHead(prose);
      const relH = h2.find((h) => /^читай також$/i.test(h.textContent.trim())) || null;
      if (quiz) {
        const content = h2.filter((h) => h !== faqH && h !== relH);
        const at = content.length >= 4 ? content[2] : faqH;
        if (at) prose.insertBefore(quiz, at); else prose.appendChild(quiz);
      }
      if (prods) {
        const at = faqH || relH;
        if (at) prose.insertBefore(prods, at); else prose.appendChild(prods);
      }
    }

    /* FAQ-акордеон: .lacc-item[data-lacc] > .lacc-q[data-lacc-q] + .lacc-a; клік / Enter / Space; перший пункт відкритий з розмітки (is-open) */
    _bindFaq() {
      const qs = this.querySelectorAll('[data-lacc-q]');
      if (!qs.length) return;
      qs.forEach((q) => {
        const it = q.closest('[data-lacc]');
        if (it) q.setAttribute('aria-expanded', it.classList.contains('is-open') ? 'true' : 'false');
      });
      const toggle = (q) => {
        const it = q.closest('[data-lacc]');
        if (!it) return;
        const on = it.classList.toggle('is-open');
        q.setAttribute('aria-expanded', on ? 'true' : 'false');
      };
      this.addEventListener('click', (e) => {
        const q = e.target.closest ? e.target.closest('[data-lacc-q]') : null;
        if (q && this.contains(q)) toggle(q);
      });
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        const q = e.target.closest ? e.target.closest('[data-lacc-q]') : null;
        if (!q || !this.contains(q)) return;
        e.preventDefault();
        toggle(q);
      });
    }

    /* CTA «Пройти тест» у тілі старих статей (<a href="#" class="btn" data-lystia-quiz-trigger>): URL сторінки квізу + primary-кнопка */
    _fixBodyCta() {
      const url = this.dataset.quizUrl;
      this.querySelectorAll('.prose [data-lystia-quiz-trigger]').forEach((a) => {
        if (url) a.setAttribute('href', url);
        a.classList.add('btn', 'btn--primary');
        if (!a.querySelector('.btn__label')) {
          const span = document.createElement('span');
          span.className = 'btn__label';
          while (a.firstChild) span.appendChild(a.firstChild);
          a.appendChild(span);
        }
      });
    }

    /* Sticky «Підібрати чай» (мобайл): після 40% статті; ховається, коли квіз у тексті на екрані; веде до квізу в тексті, якщо він є */
    _bindSticky() {
      const st = this.querySelector('[data-art-sticky]');
      const col = this.querySelector('[data-art-col]');
      if (!st || !col) return;
      const quiz = this.querySelector('[data-art-quiz]');
      const link = st.querySelector('[data-art-sticky-link]');
      if (quiz && link) {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          quiz.scrollIntoView({ behavior: this._reduced() ? 'auto' : 'smooth', block: 'start' });
        });
      }
      st.hidden = false;
      let quizVisible = false;
      const update = () => {
        const r = col.getBoundingClientRect();
        const passed = -r.top / Math.max(1, r.height);
        st.classList.toggle('is-on', passed > 0.4 && r.bottom > window.innerHeight && !quizVisible);
      };
      if (quiz && 'IntersectionObserver' in window) {
        this._io = new IntersectionObserver((en) => { quizVisible = en.some((x) => x.isIntersecting); update(); });
        this._io.observe(quiz);
      }
      this._onScrollSticky = update;
      window.addEventListener('scroll', update, { passive: true });
      update();
    }

    /* «Що заварити»: стрілки гортають на ширину картки; без переповнення стрілки сховані, на краях - disabled */
    _bindProdsNav() {
      const row = this.querySelector('[data-art-prods-row]');
      const ctrl = this.querySelector('[data-art-prods-ctrl]');
      if (!row || !ctrl) return;
      const prev = ctrl.querySelector('[data-art-prods-prev]');
      const next = ctrl.querySelector('[data-art-prods-next]');
      const step = () => {
        const card = row.querySelector('.pcard');
        const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : row.clientWidth;
      };
      const sync = () => {
        const max = row.scrollWidth - row.clientWidth;
        ctrl.hidden = max <= 2;
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= max - 2;
      };
      prev.addEventListener('click', () => row.scrollBy({ left: -step() }));
      next.addEventListener('click', () => row.scrollBy({ left: step() }));
      row.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      this._onProdsResize = sync;
      sync();
    }

    /* PostHog (якщо підключено): article_quiz_view / article_quiz_answer / article_product_click / article_sticky_click */
    _bindTrack() {
      const ph = () => (window.posthog && typeof window.posthog.capture === 'function' ? window.posthog : null);
      const slug = location.pathname.split('/').pop();
      const send = (ev, props) => { const p = ph(); if (p) p.capture(ev, Object.assign({ slug }, props || {})); };
      const quiz = this.querySelector('[data-art-quiz]');
      if (quiz && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((en) => {
          if (en.some((x) => x.isIntersecting)) { send('article_quiz_view'); io.disconnect(); }
        }, { threshold: 0.5 });
        io.observe(quiz);
      }
      this.addEventListener('click', (e) => {
        const t = e.target.closest ? e.target : null;
        if (!t) return;
        const opt = t.closest('[data-art-quiz-opt]');
        if (opt) { send('article_quiz_answer', { effect: opt.getAttribute('data-art-quiz-opt') }); return; }
        const card = t.closest('[data-art-prods] .pcard');
        if (card) { send('article_product_click', { product: card.getAttribute('data-handle') || '' }); return; }
        if (t.closest('[data-art-sticky-link]')) send('article_sticky_click');
      });
    }

    _reduced() {
      return document.lystia && document.lystia.reducedMotion
        ? document.lystia.reducedMotion()
        : window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /* Транслітерація укр. заголовка -> id (shcho-potribno-shchob-zavaryty-chai); порожній результат -> нумерація s1, s2, ... */
    _slug(text) {
      const map = { а: 'a', б: 'b', в: 'v', г: 'h', ґ: 'g', д: 'd', е: 'e', є: 'ie', ж: 'zh', з: 'z', и: 'y', і: 'i', ї: 'i', й: 'i', к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'kh', ц: 'ts', ч: 'ch', ш: 'sh', щ: 'shch', ь: '', ю: 'iu', я: 'ia', ы: 'y', э: 'e', ё: 'io', ъ: '' };
      const out = Array.from(text.toLowerCase()).map((ch) => (map[ch] !== undefined ? map[ch] : ch)).join('');
      return out.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60).replace(/-+$/, '');
    }

    /* Зміст: h2 з тексту статті; id генерує JS (транслітерація заголовка, дубль/порожнє -> -2, s1, ...), наявні id зберігаються. Показується від data-toc-min пунктів. */
    _buildToc() {
      this._heads = [];
      this._links = [];
      const prose = this.querySelector('[data-art-prose]');
      const inline = this.querySelector('[data-toc-inline]');
      const side = this.querySelector('[data-toc-side]');
      if (!prose || !inline || !side) return;
      const heads = Array.from(prose.querySelectorAll('h2')).filter((h) => h.textContent.trim());
      const min = Number(this.dataset.tocMin) || 3;
      if (heads.length < min) return;
      const taken = new Set(Array.from(prose.querySelectorAll('[id]')).map((e) => e.id));
      let n = 0;
      heads.forEach((h) => {
        if (h.id) return;
        const base = this._slug(h.textContent.trim());
        let id = base;
        if (!id || taken.has(id) || document.getElementById(id)) {
          let k = 1;
          if (base) { do { k += 1; id = base + '-' + k; } while (taken.has(id) || document.getElementById(id)); }
          else { do { n += 1; id = 's' + n; } while (taken.has(id) || document.getElementById(id)); }
        }
        h.id = id;
        taken.add(id);
      });
      this.querySelectorAll('[data-toc-list]').forEach((ol) => {
        heads.forEach((h) => {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = '#' + h.id;
          a.dataset.id = h.id;
          a.textContent = h.textContent.trim();
          li.appendChild(a);
          ol.appendChild(li);
          this._links.push(a);
        });
      });
      this._heads = heads;
      inline.hidden = false;
      side.hidden = false;
      this.addEventListener('click', (e) => {
        const a = e.target.closest ? e.target.closest('.toc a[data-id]') : null;
        if (!a) return;
        e.preventDefault();
        const el = document.getElementById(a.dataset.id);
        if (el) el.scrollIntoView({ behavior: this._reduced() ? 'auto' : 'smooth', block: 'start' });
      });
    }

    /* Індикатор читання: p = clamp(-top / (height - 0.6*innerHeight), 0, 1) по колонці статті; rAF-throttle.
       Поточний пункт змісту: останній h2 з top < 140. */
    _bindProgress() {
      const col = this.querySelector('[data-art-col]');
      const bar = this.querySelector('[data-art-progress]');
      const fill = bar ? bar.firstElementChild : null;
      if (!col) return;
      if (bar) bar.hidden = false;
      const tick = () => {
        this._raf = 0;
        if (fill) {
          const r = col.getBoundingClientRect();
          const total = r.height - window.innerHeight * 0.6;
          const p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
          fill.style.transform = 'scaleX(' + p.toFixed(4) + ')';
        }
        if (this._links.length) {
          let cur = null;
          this._heads.forEach((h) => { if (h.getBoundingClientRect().top < 140) cur = h.id; });
          this._links.forEach((a) => a.classList.toggle('is-cur', a.dataset.id === cur));
        }
      };
      this._onScroll = () => { if (!this._raf) this._raf = requestAnimationFrame(tick); };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll);
      tick();
    }

    /* Поділитися: navigator.share -> clipboard -> textarea+execCommand; тост «Посилання скопійовано» / «Не вдалося скопіювати» */
    _bindShare() {
      const btn = this.querySelector('[data-art-share]');
      if (!btn) return;
      const toast = (ok) => {
        const t = document.lystiaToast;
        if (t) t.show(ok ? this.dataset.shareOk : this.dataset.shareFail, { icon: ok ? 'check' : 'alert' });
      };
      btn.addEventListener('click', async () => {
        const url = location.href;
        try {
          if (navigator.share) { await navigator.share({ title: this.dataset.shareTitle, url }); return; }
        } catch (err) {
          if (err && err.name === 'AbortError') return;
        }
        let ok = false;
        try { await navigator.clipboard.writeText(url); ok = true; } catch (err) {
          try {
            const ta = document.createElement('textarea');
            ta.value = url;
            ta.style.cssText = 'position:fixed;opacity:0';
            document.body.appendChild(ta);
            ta.select();
            ok = document.execCommand('copy');
            ta.remove();
          } catch (err2) { ok = false; }
        }
        toast(ok);
      });
    }
  }
  customElements.define('lystia-article', LystiaArticle);
}
